import { render, staticRenderFns } from "./SectionLarge.vue?vue&type=template&id=99001776&scoped=true&"
import script from "./SectionLarge.vue?vue&type=script&lang=ts&"
export * from "./SectionLarge.vue?vue&type=script&lang=ts&"
import style0 from "./SectionLarge.vue?vue&type=style&index=0&id=99001776&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99001776",
  null
  
)

export default component.exports